// extracted by mini-css-extract-plugin
export default {"signUpBtn":"landing_signUpBtn__142BA"};